import { render, staticRenderFns } from "./PriceEditDialog.vue?vue&type=template&id=2550e175&scoped=true"
import script from "./PriceEditDialog.vue?vue&type=script&lang=js"
export * from "./PriceEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceEditDialog.vue?vue&type=style&index=0&id=2550e175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550e175",
  null
  
)

export default component.exports